import React, { useState, useRef, useEffect, Fragment } from 'react'
import ToolTip from '../../Tooltip/Tooltip'
import Field from '../../Field/Field'
import TextInput from '../../TextInput/TextInput'
import Textarea from '../../Textarea/Textarea'
import Tooltip from '../../Tooltip/Tooltip'
import FieldLabel from '../../FieldLabel/FieldLabel'
import Checkbox from '../../Checkbox/Checkbox'
import Radio from '../../Radio'
import Help from '../../Help/Help'
import Icon from '../../Icon2'
import Info from '../../Info/Info'
import TagAsSelect from '../../TagAsSelect/TagAsSelect'
import ValidationMessage from '../../ValidationMessage/ValidationMessage'
import { fieldUidRegex, getContentTypeFieldDataTestId, CONTENT_TYPE_FIELD_ACTION_IDS, validateMinHeight, validateMaxHeight, NonLocalizableDom, handleToggleClick } from '../helper'
import { ToggleSwitch } from '../../..'
import { booleanTestIdFormatter } from './../../../utils/helpers'
import GroupFieldTitleToggle from "../HelperComponents/GroupFieldTitleToggle"
const FormattingOptions = [
  {
    icon: 'Undo',
    title: 'Undo',
    name: 'undo'
  },
  {
    icon: 'Redo',
    title: 'Redo',
    name: 'redo'
  },
  {
    icon: 'BlockQuote',
    title: 'Quote',
    name: 'blockquote'
  },
  {
    icon: 'Code',
    title: 'Code',
    name: 'pre'
  },
  {
    icon: 'H1',
    title: 'Heading 1',
    name: 'h1'
  },
  {
    icon: 'H2',
    title: 'Heading 2',
    name: 'h2'
  },
  {
    icon: 'H3',
    title: 'Heading 3',
    name: 'h3'
  },
  {
    icon: 'H4',
    title: 'Heading 4',
    name: 'h4'
  },
  {
    icon: 'H5',
    title: 'Heading 5',
    name: 'h5'
  },
  {
    icon: 'H6',
    title: 'Heading 6',
    name: 'h6'
  },
  {
    icon: 'Bold',
    title: 'Bold',
    name: 'bold'
  },
  {
    icon: 'Underline',
    title: 'Underline',
    name: 'underline'
  },
  {
    icon: 'Italic',
    title: 'Italic',
    name: 'italic'
  },
  {
    icon: 'StrikeThrough',
    title: 'Strikethrough',
    name: 'deleted'
  },
  {
    icon: 'SuperScript',
    title: 'Superscript',
    name: 'sup'
  },
  {
    icon: 'SubScript',
    title: 'Subscript',
    name: 'sub'
  },
  {
    icon: 'InlineCode',
    title: 'Inline code',
    name: 'inlinecode'
  },
  {
    icon: 'List',
    title: 'Lists',
    name: 'lists'
  },
  {
    icon: 'Alignment',
    title: 'Alignment',
    name: 'alignment'
  },
  {
    icon: 'RemoveFormatting',
    title: 'Remove Format',
    name: 'removeFormatting'
  }
]
type HeightType = 'min' | 'max';

const JsonRte = (props: any) => {
  const FormattingObjects = [
    {
      icon: 'Video',
      title: 'Video',
      name: 'video'
    },
    {
      icon: 'Assets',
      title: 'Asset',
      name: 'imagemanager'
    },
    {
      icon: 'Divider',
      title: 'Divider',
      name: 'hr'
    },
    {
      icon: 'Table',
      title: 'Table',
      name: 'table'
    },
    {
      icon: 'Properties',
      title: 'Properties',
      name: 'properties'
    },
    {
      icon: 'Link',
      title: 'Link',
      name: 'link'
    },
    {
      icon: 'Embed',
      title: 'Embed',
      name: 'widget'
    }
  ]
  const {
    onChange,
    options,
    parentInfo,
    uniqueKey,
    schema,
    type,
    openModalCb,
    openExtensionModalCb,
    enableEmbeddedObj,
    enableSocialEmbed,
    plans = {},
    maxMultipleJsonRte = 100,
    isNonLocalizable,
    hasNonLocalizablePlan,
    hasNonLocalizablePlanForBlocksAndGroupMultiple
  } = props

  const { display_name, uid, field_metadata, reference_to, plugins } = schema

  const preSelectedVal =
    reference_to && reference_to.length
      ? reference_to
        .filter((val) => val !== 'sys_assets')
        .map((val) => {
          return {
            id: val,
            label: val,
            title: val
          }
        })
      : []
  const preSelectedPluginsVal =
    plugins && plugins.length
      ? plugins.map((val) => ({
        id: val,
        label: val,
        title: val
      }))
      : []

  const [initialSchema, setSchema] = useState(schema)
  const [referenceValue, setReference] = useState(preSelectedVal)
  const [pluginsValue, setPlugins] = useState(preSelectedPluginsVal)

  const [selectall, setSelectAll] = useState(false)
  const [error, setError] = useState(fieldUidRegex(schema.uid, schema))

  const displayNameRef: any = useRef(null)

  useEffect(() => {
    displayNameRef?.current?.focus()
  }, [displayNameRef])

  const correctEmbedState = () => {
    const widgetIndex = field_metadata.options?.indexOf('widget')
    const embedEntry = field_metadata['embed_entry']
    if (embedEntry && widgetIndex === -1) {
      field_metadata.options?.push('widget')
    } else if (!embedEntry && widgetIndex !== -1) {
      field_metadata.options?.splice(widgetIndex, 1)
    }
  }

  useEffect(() => {
    if (field_metadata.rich_text_type === 'custom') {
      correctEmbedState()
      onchange()
    }
  }, [field_metadata.rich_text_type])

  if (enableSocialEmbed && field_metadata.rich_text_type === 'custom') {
    if (!FormattingObjects.some((format) => format['name'] === 'social-embeds')) {
      FormattingObjects.push({
        icon: 'SocialEmbed',
        title: 'Social Embed',
        name: 'social-embeds'
      })
    }
  }

  const onchange = () => {
    onChange && onChange(schema)
    setSchema({ ...schema })
  }
  const onDisplayNameChange = (event: any) => {
    schema.display_name = event.target.value

    if (schema.hasOwnProperty('display_name') && schema.newfield) {
      schema.uid = schema.display_name
        .trim()
        .replace(/[^A-Z0-9]+/gi, '_')
        .toLowerCase()
      if (schema.display_name) {
        schema.error_details = {
          ...schema.error_details,
          uid: ''
        }
      }
    }

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.display_name.length) {
      schema.error_details = {
        ...schema.error_details,
        display_name: 'Display Name cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        display_name: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onUidChange = (event: any) => {
    setError(fieldUidRegex(event.target?.value?.trim(), schema))

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.uid.length) {
      schema.error_details = {
        ...schema.error_details,
        uid: 'uid cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        uid: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onInstructionChange = (event: any) => {
    field_metadata.instruction = event.target.value
    onchange()
  }
  const onHelpTextChange = (event: any) => {
    field_metadata.description = event.target.value
    onchange()
  }

  const validateHeight = (type: HeightType, minHeightNum: number, maxHeightNum: number, schema) => {
    switch (type) {
      case 'min':
        validateMinHeight(minHeightNum, maxHeightNum, schema);
        validateMaxHeight(minHeightNum, maxHeightNum, schema, true);
        break;
      case 'max':
        validateMaxHeight(minHeightNum, maxHeightNum, schema);
        validateMinHeight(minHeightNum, maxHeightNum, schema, true);
        break;
      default:
        break;
    }
  }
  const onMinHeightChange = (event: any) => {
    field_metadata.min_height = event.target.value.trim()

    if (!schema.error_details) {
      schema.error_details = {}
    }
    const minHeight = field_metadata.min_height
    const maxHeight = field_metadata.max_height

    const minHeightNum = minHeight !== '' ? parseInt(minHeight) : null;
    const maxHeightNum = maxHeight !== '' ? parseInt(maxHeight) : null;

    validateHeight('min', minHeightNum, maxHeightNum, schema)
    onchange()
  }
  const onMaxHeightChange = (event: any) => {
    field_metadata.max_height = event.target.value.trim()

    if (!schema.error_details) {
      schema.error_details = {}
    }
    const minHeight = field_metadata.min_height
    const maxHeight = field_metadata.max_height

    const minHeightNum = minHeight !== '' ? parseInt(minHeight) : null;
    const maxHeightNum = maxHeight !== '' ? parseInt(maxHeight) : null;

    validateHeight('max', minHeightNum, maxHeightNum, schema)
    onchange()
  }
  const onOptionsChange = (event: any) => {
    if (event.target.name === `${uniqueKey}.embed_object`) {
      if (event.target.checked) {
        field_metadata['embed_entry'] = true
        field_metadata['ref_multiple_content_types'] = true
      } else {
        field_metadata['embed_entry'] = false
      }

      if (field_metadata.rich_text_type === 'custom') {
        const widgetIdx = field_metadata.options.indexOf('widget'),
          isWidget = widgetIdx !== -1
        if (event.target.checked && !isWidget) {
          field_metadata.options.push('widget')
          // mark selectAll if current selection makes all selected
          if (FormattingOptions.length + FormattingObjects.length === field_metadata.options.length) {
            setSelectAll(true)
          }
        } else if (!event.target.checked && isWidget) {
          // clear selectAll on desection of any option
          setSelectAll(false)
          field_metadata.options.splice(widgetIdx, 1)
        }
      }

      schema['reference_to'] = ['sys_assets']
    }
    if (event.target.name === `${uniqueKey}.mandatory`) {
      schema.mandatory = event.target.checked
    }
    if (event.target.name === `${uniqueKey}.multiple`) {
      if (event.target.checked) field_metadata.isTitle = false;
      schema.multiple = event.target.checked
      schema.error_details = {
        ...schema.error_details,
        max_instance: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
      if (!schema.multiple) {
        delete schema.max_instance
      }
    }
    if (event.target.name === `${uniqueKey}.nonLocalization`) {
      if (event.target.checked && parentInfo.hasParent && hasNonLocalizablePlanForBlocksAndGroupMultiple) {
        handleToggleClick(event, parentInfo.data_type, schema, onchange, 'nonLocalizable', props.t , parentInfo.isInsideMultiple ,parentInfo.ancestorWithMultipleType)
      }
      else {
        schema.non_localizable = event.target.checked
      }
    }
    onchange()
  }
  const onEditorTypeChange = (event: any) => {
    if (event.target.value === 'basic') {
      field_metadata.rich_text_type = 'basic'
    }
    if (event.target.value === 'advanced') {
      field_metadata.rich_text_type = 'advanced'
    }
    if (event.target.value === 'custom') {
      field_metadata.rich_text_type = 'custom'
    }
    onchange()
  }
  const onFormatOptionsChange = (e: any, value: any) => {
    e.preventDefault()

    if (!(field_metadata.options && Array.isArray(field_metadata.options))) {
      field_metadata.options = []
    }

    let currentPosition = field_metadata.options.indexOf(value)
    if (currentPosition != -1) {
      // clear selectAll on desection of any option
      setSelectAll(false)
      field_metadata.options.splice(currentPosition, 1)
    } else {
      field_metadata.options.push(value)
      // mark selectAll if current selection makes all selected
      if (FormattingOptions.length + FormattingObjects.length === field_metadata.options.length) {
        setSelectAll(true)
      }
    }
    if (value === 'widget') {
      field_metadata['embed_entry'] = currentPosition === -1
    }
    onchange()
  }

  const onMaxInstance = (event: any) => {
    schema.max_instance = event.target.value ? event.target.value : null

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (event.target.value.length && schema.max_instance < 1) {
      schema.error_details = {
        ...schema.error_details,
        max_instance: 'max instance cannot be less than 1'
      }
      schema.error = true
    } else if (Number.parseInt(event.target.value) > maxMultipleJsonRte) {
      schema.error_details = {
        ...schema.error_details,
        max_instance: `max instance for json rte cannot exceed ${maxMultipleJsonRte}`
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        max_instance: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }

    onchange()
  }

  const onSelectAll = (event: any) => {
    if (event.target.checked) {
      setSelectAll(true)

      if (!field_metadata.options) field_metadata.options = []

      FormattingOptions.forEach((item) => {
        if (field_metadata.options.indexOf(item.name) == -1) {
          field_metadata.options.push(item.name)
        }
      })

      FormattingObjects.forEach((item) => {
        if (field_metadata.options.indexOf(item.name) == -1) {
          field_metadata.options.push(item.name)
        }
      })
      field_metadata['embed_entry'] = true
    } else {
      setSelectAll(false)
      field_metadata['embed_entry'] = false
      field_metadata.options = []
    }

    onchange()
  }

  const handleRefUpdate = (selectedRefs) => {
    let newSelectedRef = selectedRefs.length
      ? selectedRefs
        .filter((val) => val !== 'sys_assets')
        .map((val) => {
          return {
            id: val,
            label: val,
            title: val
          }
        })
      : []

    setReference(newSelectedRef)
    if (Array.isArray(selectedRefs) && selectedRefs.length) schema.reference_to = selectedRefs
    else delete schema.reference_to
    onchange()
  }

  const handlePluginUpdate = (selectedPlugins) => {
    let newSelectedPlugin = selectedPlugins.length
      ? selectedPlugins.map((val) => {
        return {
          id: val,
          label: val,
          title: val
        }
      })
      : []
    setPlugins(newSelectedPlugin)
    if (Array.isArray(selectedPlugins) && selectedPlugins.length) schema.plugins = selectedPlugins
    else delete schema.plugins
    onchange()
  }

  if (type === 'basic') {
    return (
      <Fragment>
        <div className="FormFields">
          <Field>
            <FieldLabel className='FieldLabel__CT' testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}-label`} version='v2' required htmlFor="displayName">
              Display Name
            </FieldLabel>
            <TextInput
              version='v2'
              required
              name={`${uniqueKey}.displayName`}
              value={display_name}
              onChange={onDisplayNameChange}
              inputRef={displayNameRef}
              error={schema.error && schema.error_details.display_name ? true : false}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel className='FieldLabel__CT' version='v2' testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}-label`} required htmlFor="uid">
              Unique ID
            </FieldLabel>
            <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}-help-text`} text="A unique ID for this field. This should not be same as the ID of any other field in this content type." />
            <TextInput
              version='v2'
              required
              name={`${uniqueKey}.uid`}
              value={uid}
              onChange={onUidChange}
              error={(schema.error && schema.error_details.uid) || error ? true : false}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel className='FieldLabel__CT' version='v2' testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}-label`} htmlFor="instruction">Instruction Value</FieldLabel>
            <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}-help-text`} text="Helps you add instructions for this field. The instructional text will appear below the field." />
            <Textarea
              version='v2'
              name={`${uniqueKey}.instruction`}
              value={field_metadata.instruction || ''}
              onChange={onInstructionChange}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
              id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
            />
          </Field>
          <Field>
            <FieldLabel className='FieldLabel__CT' version='v2' testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}-label`} htmlFor="helpText">Help Text</FieldLabel>
            <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}-help-text`} text="Provide additional info about the field. The help text will appear when the user hovers on the ‘?’ sign beside the field name." />
            <Textarea
              version='v2'
              name={`${uniqueKey}.helpText`}
              value={field_metadata.description || ''}
              onChange={onHelpTextChange}
              placeholder={props.t(
                'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
              )}
              // multiline={true}
              testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
              id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
            />
          </Field>

          {plans['rtePlugin'] && (
            <Field>
              <FieldLabel className='FieldLabel__CT' version='v2' testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.SELECT_PLUGINS_TAG_AS_SELECT)}-label`} htmlFor="referencedExtension">Select JSON RTE Plugin(s)</FieldLabel>
              <Help
                type="basic"
                testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.SELECT_PLUGINS_TAG_AS_SELECT)}-help-text`}
                text={
                  'Extend the functionality of the JSON Rich Text Editor with features such as social embeds, word count, highlights, etc.'
                }
              />
              <TagAsSelect
                version='v2'
                placeholder={'Select Plugin(s)'}
                showEmptyState={true}
                showCount={true}
                tagName={'Plugin'}
                tags={pluginsValue.length ? pluginsValue : []}
                updateTag={handlePluginUpdate}
                openModalCb={(callback) => openExtensionModalCb(callback)}
                testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.SELECT_PLUGINS_TAG_AS_SELECT)}
              />
            </Field>
          )}

        </div>
      </Fragment>
    )
  } else if (type === 'advanced') {
    return (
      <>
        <div className='FormFields flex-v-center flex-important'>
          <Field>
            <FieldLabel className='FieldLabel__CT' version='v2' testId='cs-ctf-json-rte-advanced-min-height-label' htmlFor={`${uniqueKey}.minHeight`}>
              {props.t('content_type.save_content_type.body.fields.json_rte.fields.height.min_height.label') || 'Minimum Height (in px)'}
            </FieldLabel>
            <TextInput
              version='v2'
              testId='cs-ctf-json-rte-advanced-min-height'
              name={`${uniqueKey}.minHeight`}
              value={field_metadata.min_height || ''}
              onChange={onMinHeightChange}
              error={(schema.error && schema.error_details.min_height) || error ? true : false}
              placeholder={props.t('content_type.save_content_type.body.fields.json_rte.fields.height.min_height.placeholder') || 'Enter value'}
            />
            {schema.error && schema.error_details.min_height ? (
              <ValidationMessage version='v2' testId='cs-ctf-json-rte-advanced-min-height-error' className={'error'}>{schema.error_details.min_height}</ValidationMessage>
            ) : null}
          </Field>
          <div className='seperator'>{` to `}</div>
          <Field>
            <FieldLabel className='FieldLabel__CT' version='v2' testId='cs-ctf-json-rte-advanced-max-height-label' htmlFor={`${uniqueKey}.maxHeight`}>
              {props.t('content_type.save_content_type.body.fields.json_rte.fields.height.max_height.label') || 'Maximum Height (in px)'}
            </FieldLabel>
            <TextInput
              version='v2'
              testId='cs-ctf-json-rte-advanced-maxheight'
              name={`${uniqueKey}.maxHeight`}
              value={field_metadata.max_height || ''}
              onChange={onMaxHeightChange}
              error={(schema.error && schema.error_details.max_height) || error ? true : false}
              placeholder={props.t('content_type.save_content_type.body.fields.json_rte.fields.height.max_height.placeholder') || 'Enter value'}
            />
            {schema.error && schema.error_details.max_height ? (
              <ValidationMessage version='v2' testId='cs-ctf-json-rte-advanced-min-height-error' className={'error'}>{schema.error_details.max_height}</ValidationMessage>
            ) : null}
          </Field>
        </div>
        <div className="FormFields row">
          <Field>
            <FieldLabel version='v2' className='FieldLabel__CT RadioField' testId='cs-ctf-json-rte-advanced-editor-label' htmlFor="editorType">Editor Type</FieldLabel>
            <div className="FormFields__selection-wrapper FormFields__selection-wrapper--inline">
              <Radio
                name={`${uniqueKey}.editorType`}
                value="basic"
                checked={field_metadata.rich_text_type === 'basic'}
                text="Basic"
                onChange={onEditorTypeChange}
                testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.BASIC_EDITOR_TYPE_RADIO)}
              />
              <Radio
                name={`${uniqueKey}.editorType`}
                value="advanced"
                checked={field_metadata.rich_text_type === 'advanced'}
                text="Advanced"
                onChange={onEditorTypeChange}
                testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.ADVANCED_EDITOR_TYPE_RADIO)}
              />
              <Radio
                name={`${uniqueKey}.editorType`}
                value="custom"
                checked={field_metadata.rich_text_type === 'custom'}
                text="Custom"
                onChange={onEditorTypeChange}
                testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.CUSTOM_EDITOR_TYPE_RADIO)}
              />
            </div>
          </Field>

          {field_metadata.rich_text_type === 'basic' && (
            <Info
              // style={{ marginTop: '-0.625rem', marginBottom: '0.725rem' }}
              // icon={<Icon icon="InfoCircleWhite" />}
              version='v2'
              type='light'
              testId='cs-ctf-json-rte-basic-info'
              content={
                'Provides basic formatting tools, which include undo, redo, Code, Quote, Heading 1 - Heading 6, bold, italic, underline, strike-through, alignment options'
              }
            />
          )}
          {field_metadata.rich_text_type === 'advanced' && (
            <Info
              // style={{ marginTop: '-0.625rem', marginBottom: '0.725rem' }}
              // icon={<Icon icon="InfoCircleWhite" />}
              version='v2'
              type='light'
              testId='cs-ctf-json-rte-advanced-info'
              content={
                'Provides basic formatting tools as well as options to insert images, videos, tables, links, and custom class or ID.'
              }
            />
          )}

          {field_metadata.rich_text_type === 'custom' ? (
            <>
              <div className="FormFields__row FormFields__row--separate">
                <div className="FormFields__format-heading flex-v-center">
                  <FieldLabel version='v2' testId='cs-ctf-json-rte-custom-format-options-label' htmlFor="formateoptions">Formatting Options</FieldLabel>
                  <Checkbox
                    version='v2'
                    name={`${uniqueKey}.selectall`}
                    text="Select All"
                    checked={selectall}
                    onChange={onSelectAll}
                    testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.FORMATTING_OPTIONS_SELECT_ALL_CHECKBOX)}
                  />
                </div>

                <div className="FormFields__formating-options">
                  {FormattingOptions.map((item, index) => {
                    return (
                      <ToolTip key={item.title} content={item.title} position="top">
                        <div
                          className={[
                            'FormFields__formating-option',
                            field_metadata.options && field_metadata.options.indexOf(item.name) !== -1
                              ? ' FormFields__formating-option--active'
                              : ''
                          ].join(' ')}
                          onClick={(e) => onFormatOptionsChange(e, item.name)}>
                          <Icon testId={`cs-ctf-json-rte-custom-format-option-${index}`} version='v2' className="FormFields__formating-icon" key={index} icon={item.icon} size={'small'} />
                        </div>
                      </ToolTip>
                    )
                  })}
                </div>
              </div>
              <div className="FormFields__row">
                <div className="FormFields__format-heading">
                  <FieldLabel className='FieldLabel__CT' testId='cs-ctf-json-rte-custom-insert-option-label' version='v2' htmlFor="formateoptions">Insert Object</FieldLabel>
                </div>
                <div className="FormFields__formating-options">
                  {FormattingObjects.map((item, index) => {
                    return (
                      <ToolTip key={item.title} content={item.title} position="top">
                        <div
                          className={[
                            'FormFields__formating-option',
                            field_metadata.options && field_metadata.options.indexOf(item.name) != -1
                              ? ' FormFields__formating-option--active'
                              : ''
                          ].join(' ')}
                          onClick={(e) => onFormatOptionsChange(e, item.name)}
                          data-test-id={getContentTypeFieldDataTestId(schema, type, item.title)}
                        >
                          <Icon testId={`cs-ctf-json-rte-custom-format-option-${index}`} version='v2' className="FormFields__formating-icon" key={index} icon={item.icon} size={'small'} />
                        </div>
                      </ToolTip>
                    )
                  })}
                </div>
              </div>
            </>
          ) : null}

          <div className="FormFields">
            {/* <div className="FormFields__column"> */}
            <Field className='LastField'>
              <FieldLabel className='FieldLabel__CT' testId='cs-ctf-json-rte-custom-options-label' version='v2' htmlFor="options">Options</FieldLabel>
              <div className="FormFields__selection-wrapper">
                {field_metadata.rich_text_type !== 'basic' && (
                  <Field className='InterField'>
                    <div className='ToggleWrap'>
                      <ToggleSwitch
                        label='Embed Object(s)'
                        name={`${uniqueKey}.embed_object`}
                        checked={field_metadata['embed_entry']}
                        onChange={onOptionsChange}
                        testId={booleanTestIdFormatter(getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.OPTIONS_CHEKCBOX), field_metadata['embed_entry'])}
                      />
                      <span className='ml-16'>
                        <Help
                          tippyProps={{ appendTo: document.body }}
                          alignment="right"
                          type="basic"
                          text={
                            <Fragment>
                              Lets you embed entries within the JSON Rich Text Editor field when creating entries.{' '}
                              <a
                                style={{ color: 'white' }}
                                href={
                                  'https://www.contentstack.com/docs/developers/json-rich-text-editor/about-embedded-entries-or-assets-within-json-rte/'
                                }
                                target="_blank"

                              >
                                Learn more.
                              </a>
                            </Fragment>
                          }
                          testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.LEARN_MORE)}
                        />
                      </span>
                    </div>

                    {field_metadata['embed_entry'] && (
                      <div className="embed-object-dropdown ToggleWrap__sub_Field">
                        <TagAsSelect
                          version='v2'
                          selectText="Embed Object"
                          placeholder={'Select Object(s)'}
                          showEmptyState={true}
                          showCount={true}
                          tags={referenceValue.length ? referenceValue : []}
                          updateTag={handleRefUpdate}
                          openModalCb={(callback) => openModalCb(callback)}
                          testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.SELECT_OBJECTS_TAG_AS_SELECT)}
                        />
                      </div>
                    )}
                  </Field>
                )}
                <div className='ToggleWrap'>
                  <ToggleSwitch
                    label="Mandatory"
                    name={`${uniqueKey}.mandatory`}
                    checked={schema.mandatory}
                    onChange={onOptionsChange}
                    testId={booleanTestIdFormatter(getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.MANDATORY_CHEKCBOX), schema.mandatory)}
                  />
                </div>
                <div className='ToggleWrap'>
                  <ToggleSwitch
                    label='Multiple'
                    name={`${uniqueKey}.multiple`}
                    checked={schema.multiple}
                    onChange={onOptionsChange}
                    testId={booleanTestIdFormatter(getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.MULTIPLE_CHEKCBOX), schema.multiple)}
                  />
                  <span className='ml-16'>
                    <Help
                      tippyProps={{ appendTo: document.body }}
                      type="basic"
                      alignment="right"
                      text={`Use this field property to set a maximum limit to the number of instances that can be created for this ‘Multiple’ field.`}
                    />
                  </span>
                </div>
                {schema.multiple ? (
                  <div>
                    <Field className='ToggleWrap__sub_Field'>
                      <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.SET_MAX_LIMIT_INPUT)}-label`} version='v2' className="ml-0" htmlFor="validation">
                        Set Maximum Limit
                      </FieldLabel>
                      <TextInput
                        version='v2'
                        type="number"
                        name={`${uniqueKey}.maxinstance`}
                        value={schema.max_instance || null}
                        onChange={onMaxInstance}
                        // placeholder="Maximum"
                        placeholder={props.t(
                          'content_type.save_content_type.body.fields.common_properties.placeholders.maximum'
                        )}
                        error={schema.error && schema.max_instance ? true : false}
                        testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.SET_MAX_LIMIT_INPUT)}
                      />
                    </Field>
                  </div>
                ) : null}
                {
                  hasNonLocalizablePlan ? (
                    hasNonLocalizablePlanForBlocksAndGroupMultiple ? (
                      <NonLocalizableDom
                        isFieldPresent={true}
                        uniqueKey={uniqueKey}
                        schema={schema}
                        onOptionsChange={onOptionsChange}
                        dataTestId={booleanTestIdFormatter(schema.nonLocParams?.insideMultiple ? `${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.NON_LOCALIZABLE_CHEKCBOX)}-parent-multiple` : `${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.NON_LOCALIZABLE_CHEKCBOX)}`, schema.non_localizable)}
                        dataTestIdForDescription={"cs-ct-field-json-rte-non-localizable-description"}
                        isNonLocalizable={isNonLocalizable}
                        isAncestorNonLoc ={parentInfo.isAncestorNonLoc}
                      />
                    ) : (parentInfo.hasParent ? !parentInfo.isInsideMultiple : true) ?
                      <NonLocalizableDom
                        isFieldPresent={true}
                        uniqueKey={uniqueKey}
                        schema={schema}
                        onOptionsChange={onOptionsChange}
                        dataTestId={booleanTestIdFormatter(getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.NON_LOCALIZABLE_CHEKCBOX), schema.non_localizable)}
                        dataTestIdForDescription={"cs-ct-field-json-rte-non-localizable-description"}
                        isNonLocalizable={isNonLocalizable}
                        isAncestorNonLoc ={parentInfo.isAncestorNonLoc}
                      />
                      : null
                  ) : null
                }
              </div>
            </Field>
            <GroupFieldTitleToggle
              parentInfo={parentInfo}
              uniqueKey={uniqueKey}
              field_metadata={field_metadata}
              onchange={onchange}
              multiple={schema?.multiple}
              testId="cs-ct-field-jsonrte-group-title"
            />
          </div>
        </div>
      </>
    )
  }
}

export default React.memo(JsonRte)
